import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Logo from "../SmartEvacLogo.jpg";
import NewLogo from '../NewSmartEvacLogo.png';
import DisLogo from '../DisabledSmartEvac.png';
import { useNavigate } from 'react-router-dom';


const AWS = require('aws-sdk');
const params = {
  TableName: "Other_table"
};


function Disabled() {
  const [data, setData] = useState([]);
  const navigate = useNavigate(); 

  const fetchData = async () => {
      const dynamoDB = new AWS.DynamoDB.DocumentClient();
      dynamoDB.scan(params, (err, result) => {
        if (err) {
          console.error('Error scanning the table');
        } else {
          console.log('Scan succeeded:', JSON.stringify(result, null, 2));
          setData(result.Items);
        }
      });
    };

  const handleStart = (event) => {
    event.preventDefault();
    navigate('/start'); 
  };
  

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container className= "main-page-content">
      <Row className="justify-content-center">
        <Col xs={12} sm={10} md={8} lg={6}>
          <img className="napp-logo" src={DisLogo} width="200" height="160" alt="SmartEvac Logo" />
          <h3>Evacuation has started</h3>
          <h3>Persons yet to be detected:</h3>
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Forename</th>
                <th>Surname</th>
                <th>Check</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td>{item.UserID}</td>
                  <td>{item.fname}</td>
                  <td>{item.sname}</td>
                  <input type="checkbox" className="checkbox"></input>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="SignUpIndicator">
            <span className="SignUpQuestion"></span>
            <a href="#" onClick={handleStart}>Return</a>
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default Disabled;
